import type { IPromise, IQService } from "angular";
import type { IModule } from "../interfaces/IModule";
import type { IRouteConfig } from "../interfaces/IRouteConfig";
import { angularAMD } from "../angularAmd/angularAmd";

export class PebbleAmdRoute<T> {
    public readonly resolve: { [key: string]: any };
    public readonly import: () => Promise<IModule<T>>;
    public readonly controller: string;
    private _assetsLoaded: boolean;
    private readonly _afterImport: null | (() => Promise<void>);

    constructor(routeConfig: IRouteConfig<T>) {
        this.import = routeConfig.import;
        this.controller = routeConfig.controller;
        this._afterImport = routeConfig.afterImport || null;
        this._assetsLoaded = false;
        this.resolve = ["$q", ($q: IQService) => {
            return this._resolveController($q);
        }];
    }

    private _resolveController($q: IQService): IPromise<void> {
        if (this._assetsLoaded) {
            return $q.when();
        }
        const deferred = $q.defer<void>();
        this.import()
            .then((module: IModule<T>) => {
                angularAMD.controller(this.controller, module.Controller);
                if (this._afterImport !== null) {
                    return this._afterImport();
                }
                return;
            })
            .then(() => {
                this._assetsLoaded = true;
                deferred.resolve();
            })
            .catch((error) => {
                deferred.reject(error);
            });

        return deferred.promise;
    }
}
